/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { I18NDto } from '../../models/i-18-n-dto';

export interface I18NClientControllerFindAllV1$Params {
}

export function i18NClientControllerFindAllV1(http: HttpClient, rootUrl: string, params?: I18NClientControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<I18NDto>>> {
  const rb = new RequestBuilder(rootUrl, i18NClientControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<I18NDto>>;
    })
  );
}

i18NClientControllerFindAllV1.PATH = '/api/v1/i18n/client';
